import MenuNames from "../../../constants/Menu/MenuNames.json";
import DriverStoreMappings from "../../../views/DriverStoreMappings";

const DriverStoreMappingsRoutes = [
  {
    menuName: MenuNames.SLOT_CAPACITY_UPDATE,
    path: "/driver-store-mapping-upload",
    component: DriverStoreMappings,
    exact: true,
  },
];

export default DriverStoreMappingsRoutes;
